export default "__VITE_ASSET__4cda03cf__"